class PromoTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initTabs();
  }

  initTabs() {
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.tabList = this.querySelector('[role="tablist"]');

    // Add a click event handler to each tab
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => this.changeTabs(e));
    });
  }

  changeTabs(e) {
    const target = e.target.closest('[role="tab"]');
    if (!target) return;
    const parent = target.parentNode;

    // Remove all current selected tabs
    this.querySelectorAll('[aria-selected="true"]').forEach((t) => {
      t.setAttribute('aria-selected', "false")
    });

    // Set this tab as selected
    target.setAttribute('aria-selected', true);

    // Hide all tab panels
    this.querySelectorAll('[role="tabpanel"]').forEach((p) => p.setAttribute('hidden', true));

    // Show the selected panel
    this.querySelector(`#${target.getAttribute('aria-controls')}`).removeAttribute('hidden');
  }
}

customElements.define('promo-tabs', PromoTabs);